import { Injectable } from '@angular/core';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class LinkedAccountService extends BackendBaseService {
  url = 'admin/linked_accounts';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }
  
  intranets(): Promise<any> {
    return this.httpClient.get('linked_accounts/intranets.json');
  }
}
